import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect, useMemo, useRef } from 'react';

import { DrawerService } from './drawer-service';
import { DrawerCallbackData, DrawerObserver } from './types';

export function useDrawer() {
  const navigate = useNavigate();
  const observer = useRef<DrawerObserver>();

  const service = useMemo(
    () =>
      new DrawerService({
        search: (params) =>
          navigate({
            to: '.',
            search: (oldParams: Record<string, unknown>) => ({ ...oldParams, ...params }),
            resetScroll: false,
          }),
        searchReplace: (params) =>
          navigate({
            to: '.',
            search: (oldParams: Record<string, unknown>) => ({ ...oldParams, ...params }),
            replace: true,
            resetScroll: false,
          }),
        getDrawerObserver: (_observer) => (observer.current = _observer),
      }),
    [navigate],
  );

  const { entity, entityId, drawerOrigin } = useSearch({
    strict: false,
    select(search: Record<string, unknown>): DrawerCallbackData {
      const ns = service.getNamespace();
      const origin = search[ns.origin];
      return {
        // @ts-expect-error - Generic library code, route types not known at compile time
        entity: search[ns.entity],
        // @ts-expect-error - Generic library code, route types not known at compile time
        entityId: search[ns.entityId],
        drawerOrigin: origin === 'control' || origin === 'program_control' ? origin : undefined,
      };
    },
  });

  useEffect(() => {
    observer.current?.(entity ? { entity, entityId, drawerOrigin } : undefined);
  }, [entity, entityId, drawerOrigin]);

  return service;
}
